import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
/** Mobile-only purchase bar that appears once the visitor scrolls past the hero. */
export function StickyBuyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-310" data-mp="3vebro037qpuh">
      {isVisible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-600 bg-night-950 px-4 py-3 sm:hidden" data-id="element-311" data-mp="3vd0qm815jw72">
          <div className="flex items-center justify-between gap-4" data-id="element-312" data-mp="1w3c4jdaokq44">
            <div data-id="element-313" data-mp="29g0wjeopb8wp">
              <p className="flex items-baseline gap-2" data-id="element-314" data-mp="29gkfmyq383cb">
                <span className="font-display text-3xl leading-none text-amber" data-id="element-315" data-mp="2ed15bxcxqpri">$27</span>
                <span className="text-xs leading-none text-cream-muted line-through" data-id="element-316" data-mp="2iew5gyj4qx3p">$97</span>
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-label text-cream-muted" data-id="element-317" data-mp="2n6e3bdpuwhkg">
                Cena premierowa dziś
              </p>
            </div>
            <CtaButton data-id="element-318" data-mp="2s7lgxteokaz1">Kup teraz</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}